import { render, staticRenderFns } from "./BetDetail.component.vue?vue&type=template&id=76f75942&"
import script from "./BetDetail.component.vue?vue&type=script&lang=ts&"
export * from "./BetDetail.component.vue?vue&type=script&lang=ts&"
import style0 from "./BetDetail.component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports